import { render, staticRenderFns } from "./UserInfoTile.vue?vue&type=template&id=2022085d&scoped=true"
import script from "./UserInfoTile.vue?vue&type=script&lang=js"
export * from "./UserInfoTile.vue?vue&type=script&lang=js"
import style0 from "./UserInfoTile.vue?vue&type=style&index=0&id=2022085d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022085d",
  null
  
)

export default component.exports